import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "clip-path": "url(#a)"
    }, [
      _createElementVNode("path", { d: "M9.201 5a.83.83 0 0 1-.565-.22L6.005 2.31 3.374 4.78a.8.8 0 0 1-.26.168.84.84 0 0 1-.88-.159.8.8 0 0 1-.175-.246.7.7 0 0 1 .006-.58.8.8 0 0 1 .179-.243l3.196-3c.15-.141.353-.22.565-.22s.415.079.565.22l3.196 3a.74.74 0 0 1 .219.384.7.7 0 0 1-.046.433.76.76 0 0 1-.294.336.84.84 0 0 1-.444.127M6.005 12.5a.83.83 0 0 1-.565-.22l-3.196-3a.8.8 0 0 1-.18-.243.71.71 0 0 1 .17-.827.8.8 0 0 1 .262-.163.85.85 0 0 1 .878.173l2.631 2.47 2.631-2.47a.83.83 0 0 1 .562-.21c.21 0 .41.08.558.219s.232.327.234.524a.73.73 0 0 1-.224.527l-3.196 3a.83.83 0 0 1-.565.22" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 .5h12v12H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }